
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ScimIconWrapper',
  props: {
    isScimEnabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    }
  }
})
